import { render } from "./InformatikQuest.vue?vue&type=template&id=38ffea21&scoped=true"
import script from "./InformatikQuest.vue?vue&type=script&lang=js"
export * from "./InformatikQuest.vue?vue&type=script&lang=js"

import "./InformatikQuest.vue?vue&type=style&index=0&id=38ffea21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ffea21"]])

export default __exports__